import React from 'react';

import styles from './EmptyStubKpi.module.scss';

const EmptyStubKpi = () => (
	<div className={styles.emptyStubKpiContainer}>
		<span>Select sites on the map to proceed</span>
		<span>with KPI analysis.</span>
	</div>
);

export default EmptyStubKpi;
